export default {
  methods: {
    mapLayerLiftmaintenanceCablesAdd () {
      this.initPollLiftmaintenanceCables()
      this.map.addSource('liftmaintenance-cables-source', {
        type: 'geojson',
        data: this.computedLiftmaintenanceCablesGeoJson
      })

      this.map.addLayer({
        id: 'liftmaintenance-cables',
        type: 'line',
        source: 'liftmaintenance-cables-source',
        paint: {
          'line-color': 'Orange',
          'line-width': 3
        },
        layout: {
          'visibility': 'visible',
          'line-join': 'round',
          'line-cap': 'round'
        }
      })
    },
    mapLayerLiftmaintenanceCablesRemove () {
      this.cancelPollLiftmaintenanceCables()
      this.map.removeLayer('liftmaintenance-cables')
      this.map.removeLayer('liftmaintenance-cables-label')
      this.map.removeSource('liftmaintenance-cables-source')
    },
    initPollLiftmaintenanceCables () {
      this.$store.dispatch('actionGetGeoJson', {
        url: '/static/lift_cables.geojson',
        dept: 'liftmaintenance',
        layer: 'cables'
      })
      this.pollLiftmaintenanceCablesInterval = setInterval(() => {
        this.$store.dispatch('actionGetGeoJson', {
          url: '/static/lift_cables.geojson',
          dept: 'liftmaintenance',
          layer: 'cables'
        })
      }, 10000)
    },
    cancelPollLiftmaintenanceCables () {
      this.pollLiftmaintenanceCablesInterval = clearInterval(this.pollLiftmaintenanceCablesInterval)
    }
  },
  computed: {
    computedLiftmaintenanceCablesGeoJson () {
      return this.$store.state.layers.liftmaintenance.mapLayers.cables.geojson
    },
    computedLiftmaintenanceCablesMapVisibility () {
      return this.$store.state.layers.liftmaintenance.mapLayers.cables.visibility.mapView
    }
  },
  watch: {
    '$store.state.layers.liftmaintenance.mapLayers.cables.geojson': {
      handler (val, oldVal) {
        if (this.computedLiftmaintenanceCablesGeoJson) {
          this.mapLayerLiftmaintenanceCablesRemove()
          this.mapLayerLiftmaintenanceCablesAdd()
        }
      }
    },
    '$store.state.layers.liftmaintenance.mapLayers.cables.visibility.mapView': function (newValue, oldValue) {
      if (newValue) {
        this.mapLayerLiftmaintenanceCablesAdd()
      } else {
        this.mapLayerLiftmaintenanceCablesRemove()
      }
    }
  },
  beforeDestroy () {
    this.cancelPollLiftmaintenanceCables()
  }
}



// WEBPACK FOOTER //
// ./src/mixins/layers/liftmaintenanceCables.js